import { Operator } from '@procureai/query-builder';
import { ReactElement, useState, useEffect, ElementType } from 'react';
import { Link, LinkProps } from 'react-router-dom';

import { QueryParam } from '~/common/types';
import { encodeQueryRules } from '~/hooks';

type ChildProps = {
  component: ElementType;
  to: LinkProps['to'];
};

export interface EncodedQueryProps {
  pathname: string;
  rules?:
    | {
        field: string;
        operator?: Operator;
        value: any;
      }[]
    | null;
  children: (props: ChildProps | null) => ReactElement<any>;
}

export const EncodedQuery = ({ pathname, rules, children }: EncodedQueryProps) => {
  const [encoded, setEncoded] = useState<ChildProps | null>(null);
  useEffect(() => {
    let active = true;
    if (rules) {
      (async () => {
        const result = await encodeQueryRules(rules);
        if (active) {
          setEncoded({
            component: Link,
            to: {
              pathname,
              search: `?${QueryParam.ENCODED_QUERY}=${result || ''}`,
            },
          });
        }
      })();
    }
    return () => {
      active = false;
    };
  }, [rules, pathname]);

  return children(encoded) || null;
};
